
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 18 18"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-stroke",attrs:{"stroke":"#798F8F","stroke-linecap":"round","d":"M7 4h4M6.5 16.5h5a2 2 0 0 0 2-2v-11a2 2 0 0 0-2-2h-5a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2Z"}})])
          )
        }
      }
    